import React, { useState } from "react";

import { Link } from "react-router-dom";

// Import menuDropdown
import LanguageDropdown from "../../Components/Common/LanguageDropdown";
import NotificationDropDown from "../../Components/CommonForBoth/NotificationDropDown";
import ProfileMenu from "../../Components/CommonForBoth/TopBarDropDown/ProfileMenu";

import logo from "../../assets/images/logo.svg";
import logoLightSvg from "../../assets/images/logo-light.svg";
import {
  LAYOUT_MODE_TYPES,
  LEFT_SIDEBAR_THEME_TYPES,
} from "Components/constants/layout";
import { createSelector } from "reselect";
import { useDispatch, useSelector } from "react-redux";
import { changeLayoutMode, changeLeftSidebarTheme } from "slices/thunk";

//i18n
import { withTranslation } from "react-i18next";

const Header = (props: any) => {
  const [search, setsearch] = useState(false);

  const dispatch = useDispatch<any>();
  const selectLayoutState = (state: any) => state.Layout;
  const selectProperties = createSelector(selectLayoutState, (layout) => ({
    layoutModeType: layout.layoutModeTypes,
  }));
  const { layoutModeType } = useSelector(selectProperties);

  const toggleFullscreen = () => {
    let document: any = window.document;
    document.body.classList.add("fullscreen-enable");
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen();
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen();
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    }
    // handle fullscreen exit
    const exitHandler = () => {
      if (
        !document.webkitIsFullScreen &&
        !document.mozFullScreen &&
        !document.msFullscreenElement
      )
        document.body.classList.remove("fullscreen-enable");
    };
    document.addEventListener("fullscreenchange", exitHandler);
    document.addEventListener("webkitfullscreenchange", exitHandler);
    document.addEventListener("mozfullscreenchange", exitHandler);
  };

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box d-lg-none d-md-block">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logo} alt="" height="22" />
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoLightSvg} alt="" height="22" />
                </span>
              </Link>
            </div>

            {/* SEARCH BUTTON */}
            <button
              type="button"
              onClick={() => tToggle()}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <form className="app-search d-none d-lg-block">
              <div className="position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={props.t("Search") + "..."}
                />
                <span className="bx bx-search-alt" />
              </div>
            </form>
          </div>
          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => setsearch(!search)}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div className="d-flex align-items-center ms-3">
              <button
                onClick={() => {
                  dispatch(
                    changeLayoutMode(
                      layoutModeType === LAYOUT_MODE_TYPES.DARK
                        ? LAYOUT_MODE_TYPES.LIGHT
                        : LAYOUT_MODE_TYPES.DARK
                    )
                  );
                  dispatch(
                    changeLeftSidebarTheme(
                      layoutModeType === LAYOUT_MODE_TYPES.DARK
                        ? LEFT_SIDEBAR_THEME_TYPES.LIGHT
                        : LEFT_SIDEBAR_THEME_TYPES.DARK
                    )
                  );
                }}
                className="btn btn-icon btn-sm rounded-circle"
                title={
                  layoutModeType === LAYOUT_MODE_TYPES.DARK
                    ? "Modo claro"
                    : "Modo oscuro"
                }
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  fontSize: "18px",
                  cursor: "pointer",
                }}
              >
                {layoutModeType === LAYOUT_MODE_TYPES.DARK ? (
                  // <FaSun />
                  <span className="mdi mdi-white-balance-sunny"></span>
                ) : (
                  // <FaMoon />
                  <span className="mdi mdi-weather-night"></span>
                )}
              </button>
            </div>

            <LanguageDropdown />
            <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon "
                data-toggle="fullscreen"
              >
                <i className="bx bx-fullscreen" />
              </button>
            </div>

            <NotificationDropDown />

            <ProfileMenu />

            {/* <div className="dropdown d-inline-block">
              <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle"
                onClick={props.toggleCanvas}
              >
                <i className="bx bx-cog bx-spin" />
              </button>
            </div> */}
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default withTranslation()(Header);
